import React, { useState } from "react";
import DashboardSide from "../dashboard/DashboardSide";
import ProductDetailCenter from "./ProductDetailCenter";
import MobileMenu from "../dashboard/MobileMenu";

export default function ProductDetail({ product }) {
  const [modal, setModal] = useState(false);
  return (
    <div className="h-full bg-[#f6f6f6] flex items-center justify-center">
      <DashboardSide />
      {modal && <MobileMenu setModal={setModal} />}
      <ProductDetailCenter setModal={setModal} product={product} />
    </div>
  );
}
